﻿import $ from "jquery";
import "./jquery-popup";

function menuFromObjectArray(o) {
	var i, l, ul = $("<ul>");
	for(i = 0, l = o.length; i < l; i++) {
		if (o[i]["icon"]) {
			ul.addClass("td-hasicons");
			break;
		}
	}
	for(i = 0, l = o.length; i < l; i++) {
		var m = o[i];
		var a = $("<a>", { href: m.href, "class": m["class"], "data-confirm": m.confirmation }).text(m.text);
		if(m["icon"]) {
			a.addClass("ui-icon-" + (m["icon"] || "custom"));
			if(m["icon-id"])
				a.attr("data-icon", m["icon-id"]);
		}
		var li = $("<li>", { "class": m["default"] ? "ui-default" : null }).append(a);
		if(m["color"])
			li.addClass("op80").css("background-color", m["color"]);
		ul.append(li);
	}
	return ul;
}

function getButtonClickFn(defUrl, defConfirm, getMenu) {
	return function (evt) {
		var button = $(this);
		if (button.prop("disabled"))
			return;
		var menu = getMenu(button);
		if (defUrl) {
			if (button.is(".btn-split")) {
				var darr = button.find(">i.ui-drop-mark");
				if (!darr.length || !darr.is(":visible") || evt.pageX < darr.offset().left) {
					menu.hide();
					if (defConfirm == null || window.confirm(defConfirm ? defConfirm : "Are you sure?")) {
						location.href = defUrl;
						evt.stopImmediatePropagation();
						return false;
					}
				}
			}
		}
		evt.preventDefault();
		if (menu.is(":visible")) {
			menu.hide();
			return;
		}
		var pos = { my: "left top", at: "left bottom", of: button };
		menu.show().position(pos);
		/* do not let popup have negative offset */
		var offset = menu.offset();
		var jpos = menu.position();
		if (offset.left < 0) jpos.left -= offset.left;
		if (offset.top < 0) jpos.top -= offset.top;
		menu.css(jpos);
		setTimeout(function () {
			$(document).one("click", function () { menu.hide(); });
		}, 0);
	};
}

$.fn.toolaction = function (options) {
	if (!options || !options.from)
		return this;

	var appendMenuTo = options.appendMenuTo || document.body;
	var menuFactory = typeof options.from === "function" ?
		options.from :
		Array.isArray(options.from) ?
			function () { return menuFromObjectArray(options.from); } :
			typeof options.from == "string" && options.from.substring(0, 6) == "@data-" ?
				(function (data) { return function (e) { return menuFromObjectArray(e.data(data)); }; })(options.from.substr(6)) :
				function () { return $(options.from); };

	return this.each(function () {
		var button = $(this);
		var menu = menuFactory(button);
		if (!menu.length)
			return;
		var hasNonDef = menu.find(">li:not(.ui-default)").length !== 0;
		var defItem = menu.find(">li.ui-default>a");
		var defUrl = defItem.attr("href");
		var defConfirm = defItem.attr("data-confirm");
		// menu is needed if there is more than one item
		if (hasNonDef) {
			var getMenu = null;
			if (defUrl)
				button.addClass("btn-split").append("<i class=\"ui-drop-mark\"/>");
			else
				button.addClass("ui-drop-mark");

			if (!menu.closest("html").length) {
				menu.addClass("ui-popup").menu();
				var a = appendMenuTo;
				if (a === "parent") {
					// a little hack. if menu is created and inserted after button, get menu item dynamically
					button.after(menu);
					getMenu = function (button) { return button.next(); };
				}
				else {
					menu.uniqueId().appendTo(a);
				}
			}
			getMenu = getMenu || function () { return $("#" + menu.attr("id")); };
			button.on("click", getButtonClickFn(defUrl, defConfirm, getMenu));
		}
	});
};